<template>
  <div>
    <app-page-container>
      <app-cells>
        <app-form-field label="Airline Invoice 📋">
          <app-uploader
            @onAddedFile="onAddedInvoice"
            v-model="reservation.airline_invoice_attachment"
            class="custom-uploader--min-150"
            :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp', 'pdf']"
            :readonly="!is_general_manager && !is_reservations_department"
          />
        </app-form-field>
      </app-cells>
      <app-cells
        v-if="reservation.reservation_status.code === 'booked' || reservation.reservation_status.code === 'booked_provisionally'"
        class="cells--end-vertical"
      >
        <app-form-field v-if="reservation.reservation_status.code === 'booked_provisionally'" label="Deadline">
          <app-date-picker
            v-model="reservation.reservation_deadline"
            placeholder="Deadline"
            :readonly="!is_general_manager && !is_reservations_department"
          />
        </app-form-field>
        <template v-if="reservation.reservation_status.code === 'booked'">
          <app-form-field label="Ticket 🎫️" required>
            <app-uploader
              v-model="reservation.ticket"
              class="custom-uploader--min-150"
              :extensions="['application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp', 'pdf']"
              :readonly="!is_general_manager && !is_reservations_department"
            />
            <template #error>
              <div v-if="$v.reservation.ticket.$dirty && !$v.reservation.ticket.required">Required field</div>
            </template>
          </app-form-field>
          <app-form-field label="PNR" label-for="pnr" required>
            <app-input
              v-model="reservation.pnr"
              name="pnr"
              id="pnr"
              :error="$v.reservation.pnr.$error"
            />
            <template #error>
              <div v-if="$v.reservation.pnr.$dirty && !$v.reservation.pnr.required">Required field</div>
            </template>
          </app-form-field>
        </template>
        <app-button @click.native="onCheckGeneralForm" ref="save_general" :disabled="$v.reservation.$error">
          Save
        </app-button>
      </app-cells>
      <app-form-field label="Reservation notes" label-for="notes">
        <app-textarea
          @change.native="onPatchReservationNotes"
          v-model="reservation.notes"
          rows="10"
          placeholder="Write a note"
          id="notes"
        />
      </app-form-field>
    </app-page-container>
  </div>
</template>

<script>
import { patchReservationsFlights } from '@/http'
import { format, parse } from 'date-fns'
import { requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'HotelsReservationsGeneral',
  props: {
    reservation: {
      type: Object,
    },
  },
  data() {
    return {
      reservation_notes: '',
    }
  },
  validations: {
    reservation: {
      ticket: {
        required: requiredIf(function() {
          return this.reservation.reservation_status.code === 'booked'
        })
      },
      pnr: {
        required: requiredIf(function() {
          return this.reservation.reservation_status.code === 'booked'
        })
      },
    }
  },
  computed: {
    is_reservations_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
  },
  methods: {
    onAddedInvoice(e) {
      let data = {}
      if (e.id) data = { airline_invoice_attachment: e.id }
      else data = { airline_invoice_attachment: null }
      this.onPatchFlight(data)
    },
    onPatchReservationNotes() {
      this.onPatchFlight({ notes: this.reservation.notes })
    },
    onPatchFlight(data) {
      patchReservationsFlights(this.$route.params.id, data)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
    onCheckGeneralForm() {
      this.$v.reservation.$touch()
      if (this.$v.reservation.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendGeneralForm()
      }
    },
    sendGeneralForm() {
      this.$refs.save_general.preload = true
      patchReservationsFlights(
        this.$route.params.id,
        {
          reservation_deadline: this.reservation.reservation_deadline,
          ticket: this.reservation.ticket && this.reservation.ticket.id ? this.reservation.ticket.id : null,
          pnr: this.reservation.pnr,
        }
      )
        .finally(() => { this.$refs.save_general.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
  }
}
</script>
